import Navbar from "../../components/feature/Navbar";
import Footer from "../../components/feature/Footer";
import HeroSection from "./components/HeroSection";
import MenuSection from "./components/MenuSection";
import GalleryPreview from "./components/GalleryPreview";
import NailistSection from "./components/NailistSection";
import TestimonialsSection from "./components/TestimonialsSection";
import StoreInfoSection from "./components/StoreInfoSection";

export default function HomePage() {
  return (
    <main>
      <Navbar />
      <HeroSection />
      <MenuSection />
      <GalleryPreview />
      <NailistSection />
      <TestimonialsSection />
      <StoreInfoSection />
      <Footer />
    </main>
  );
}
